import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Archive } from "../../../@types/archive";
import axiosInstance from "../../../utils/axiosConfig";

export const createArchive = createAsyncThunk<Archive, any, { rejectValue: string }>(
  "documentCreate/createArchive",
  async (fileOrParams, { rejectWithValue }) => {
    try {
      // Soporta tanto createArchive(file) como createArchive({ file, onProgress })
      const file: File | Blob | undefined = fileOrParams?.file ?? fileOrParams;
      const onProgress: ((percent: number) => void) | undefined = fileOrParams?.onProgress;

      if (!file) {
        throw new Error("Archivo no proporcionado");
      }

      const formData = new FormData();
      formData.append("file", file);

      const { data } = await axiosInstance.post(
        `${api.baseURL}archive`,
        formData,
        {
          // Asegura multipart. Si axiosInstance tenía 'application/json', lo sobreescribimos aquí.
          headers: { "Content-Type": "multipart/form-data" },
          // Si tu backend usa cookie/sesión y CORS con credenciales, déjalo en true. No afecta si usas solo Bearer.
          withCredentials: true,
          // Reporte de progreso opcional
          onUploadProgress: onProgress
            ? (evt) => {
                const total = evt.total ?? 0;
                const percent = total ? Math.round((evt.loaded * 100) / total) : 0;
                try {
                  if (onProgress) {
                    onProgress(percent);
                  } } catch {}
              }
            : undefined,
          // Opcional: puedes agregar validateStatus si quieres capturar ciertos códigos como error explícito
          // validateStatus: (status) => status >= 200 && status < 300,
        }
      );

      if (!data) throw new Error("No se creó el archivo");
      return data as Archive;
    } catch (err: any) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Error al subir el archivo";
      return rejectWithValue(message);
    }
  }
);
